import React, { useEffect, useState } from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { useSelector } from "react-redux";
import { updateDepartment, fetchAllDepartments } from "../../../../../redux/customer/customerSlice";
import { useDispatch } from "react-redux";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";
import { createPortal } from "react-dom";
import { useParams } from "react-router-dom";
const EditDepartment = ({ onOpen, onClose }) => {
  const dispatch = useDispatch();
const {userId}=useParams();
  //Selected department DATA
  const selectedDepartment = useSelector(
    (state) => state.customer.selectedDepartment,
  );
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("Active");
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (selectedDepartment) {
      setName(selectedDepartment.name || "");
      setType(selectedDepartment.department_type || "");
      setStatus(selectedDepartment.isActive ? "Active" : "Inactive");
    }
  }, [selectedDepartment]);

  //Update DATA
  const handleUpdate = () => {
    if (!selectedDepartment) return;

    const payload = {
      name: name.trim(),
      department_type: type || null,
      isActive: status === "Active",
    };

    dispatch(updateDepartment({ userId,departmentId: selectedDepartment._id, payload }))
      .unwrap()
      .then(() => {
        dispatch(fetchAllDepartments({ id: userId, pageNo: 1, pageSize: 100 }));
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          onClose();
        }, 2000);
      })
      .catch((err) => {
        console.error("Update failed:", err);
      });
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      <div className="p-6">
        {/* Top Inputs */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Department Name */}
          <div>
            <label className="text-sm text-gray-700">Department Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            />
          </div>

          {/* Department Type */}
          <div>
            <label className="text-sm text-gray-700">Department Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="">Select Type</option>
              <option value="Core">Core</option>
              <option value="Support">Support</option>
            </select>
          </div>

          {/* Status */}
          <div>
            <label className="text-sm text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Success Message handled via PopupCard */}
        {showSuccess &&
          createPortal(
            <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-40 px-4">
              <PopupCard
                type="success"
                title="Success"
                message="Department updated successfully!"
              />
            </div>,
            document.body,
          )}

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-8">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
          >
            Cancel
          </button>

          <button
            onClick={handleUpdate}
            className="px-6 py-2 bg-[#06513D] text-white rounded-md"
          >
            Add Details
          </button>
        </div>
      </div>
    </DailogBox>
  );
};

export default EditDepartment;
